export default {
  name: 'MenuMixin',
  // methods: {
  //   addAirpodsMenuNode() {
  //     const nodes = [...this.$store.state.categories]
  //     const result = []

  //     for (let i = 0; i < nodes.length; i++) {
  //       const item = nodes[i]

  //       if (item.slug === 'gadgets') {
  //         const gadgetsChildren = [...item.children]
  //         const airPodsCat = gadgetsChildren.find(
  //           ({ slug }) => slug === 'apple-airpods'
  //         )
  //         const airPodsStuffCat = gadgetsChildren.find(
  //           ({ slug }) => slug === 'komplektaciya-airpods'
  //         )
  //         if (airPodsCat) {
  //           if (airPodsStuffCat) {
  //             airPodsCat.children = [airPodsStuffCat]
  //           }
  //           result.push(airPodsCat)
  //         }
  //       }
  //       result.push(item)
  //     }

  //     return result
  //   },
  // },
  computed: {
    menuNodes() {
      const rootSlugs = [
        'iphone',
        'ipad',
        'mac',
        'apple-watch',
        'apple-airpods',
      ]
      // const nodes = this.addAirpodsMenuNode()
      const nodes = [...this.$store.state.categories]
      const appleItem = {
        name: this.$t('menuUsed'),
        slug: 'used',
        children: [],
      }
      const mapChildren = (source, target) => {
        source.forEach(node => {
          let name = ''
          if (node[`name_${this.$i18n.locale}`]) {
            name = node[`name_${this.$i18n.locale}`]
          } else if (node.name) {
            name = node.name
          }
          if (!node.published_used) {
            //console.log(node.published_used)
            let item = {
              name: this.$t('menuUsedTemplate', { name }),
              slug: node.slug,
              //published_used: node.published_used,
              //used: true,
              children: [],
            }
            if (node.children.length) {
              mapChildren(node.children, item.children)
            }
            target.push(item)
          }
        })
      }
      rootSlugs.forEach(cs => {
        const cat = this.$store.state.categories.find(c => c.slug === cs)
        if (!cat) return
        let name = ''
        if (cat[`name_${this.$i18n.locale}`]) {
          name = cat[`name_${this.$i18n.locale}`]
        } else if (cat.name) {
          name = cat.name
        }
        let catItem = {
          name: this.$t('menuUsedTemplate', { name }),
          // todo: CHECK
          slug: cat.slug,
          children: [],
        }
        if (cat.children) mapChildren(cat.children, catItem.children)
        appleItem.children.push(catItem)
      })
      const removedUsedDuplicates = appleItem.children.map(c => {
        let obj = {}
        obj['children'] = c.children.filter(q => !q.slug.includes('used'))
        obj['name'] = c.name
        obj['slug'] = c.slug
        return obj
      })
      appleItem.children = removedUsedDuplicates

      nodes.push(appleItem)
      return nodes
    },
  },
}
